import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import MobileGuestGate from "@/components/MobileBlockedScreen";
import WelcomePage from "@/pages/WelcomePage";
import QuestionnairePage from "@/pages/QuestionnairePage";
import ThankYouPage from "@/pages/ThankYouPage";
import AdminPanel from "@/pages/AdminPanel";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <div className="App min-h-screen relative">
          <Routes>
            <Route path="/" element={<WelcomePage />} />
            <Route path="/questions" element={<QuestionnairePage />} />
            <Route path="/thank-you" element={<ThankYouPage />} />
            <Route path="/admin" element={<AdminPanel />} />
          </Routes>
          <MobileGuestGate />
        </div>
        <Toaster position="top-center" />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
